import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Collapse, Input, QRCode, Tag, Button } from "antd";
import LoaderTeacher from "../../Loader/Loader_Teacher";
import { useContext } from "react";
import { UserContext } from "../../UserContext";
const { Panel } = Collapse;

const CourseOutline = () => {
	const [courseData, setCourseData] = useState({});
	const {courseId}  = useParams();
	const [loading, setLoading] = useState(true);
	const { studentapiuri, token } = useContext(UserContext);
	
    const navigate = useNavigate();
	

	const fetchCourseData = async () => {
		try {
			const response = await fetch(`${studentapiuri}/courses/${courseId}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
				},
			});
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();
            console.log(data);
			setCourseData(data?.data);
			
			setLoading(false);
		} catch (error) {
			console.error("Error fetching course data:", error);
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCourseData();
	}, []);


	if (loading) {
		return <LoaderTeacher loader_text={"Generating content"} />;
	}

	

	return (
		<div className="course-summary">
			<div className="section-header">Course Summary</div>
			<div className="course-summary-content">
				<div className="course-summary-title">
					<span>Course Title:</span> {courseData.courseTitle}
				</div>
				<div className="course-summary-description">
					<span>Course Description:</span>
					<br />

					<div className="course-desc">
						<div>
							<span className="tabspace"></span>
							{courseData.courseDescription}
						</div>
						<div className="qr">
							<QRCode
								value={`https://learnyourwayy.web.app/student/courses/${courseId}`}
							/>
							
						</div>
					</div>
				</div>
				<div className="course-summary-objectives">
					{courseData.courseObjective && <span>Course Objectives</span>}
					<ul>
						{courseData.courseObjective &&
							courseData.courseObjective.map((objective, index) => (
								<>
									<li key={index}>{objective}</li>
								</>
							))}
					</ul>
				</div>
				<div className="course-summary-tags">
					{courseData.courseTags && <span>Course Tags</span>}
					<div className="tags-container">
						{courseData.courseTags &&
							courseData.courseTags.map((tag, index) => (
								<>
									<Tag className="tag" key={index}>
										{tag}
									</Tag>
								</>
							))}
					</div>
				</div>
				<div className="course-summary-structure">
					<span>Course Outline</span>
					<Collapse accordion className="structure-content">
						{courseData.courseStructure &&
							courseData.courseStructure.map((module, moduleIndex) => (
								<Panel header={module.moduleName} key={moduleIndex}>
									<div className="submodules">
										<span>Sub Modules:</span>
										<ul>
											{module.subModules &&
												module.subModules.map((submodule, subModuleIndex) => (
													<>
														<li key={subModuleIndex}>
															<Input
																value={submodule}
																contentEditable={false}
															/>
														</li>
													</>
												))}
											
										</ul>
									</div>
									<div className="quizzes">
										<ul>
											{module.quiz && (
												<>
													<span>Quizzes:</span>
													<li>
														<Input
															value={module.quiz}
															contentEditable={false}
														/>
													</li>
												</>
											)}
										</ul>
									</div>
								</Panel>
							))}
					</Collapse>
				</div>
			</div>
		</div>
	);
};

export default CourseOutline;
